import fetchData from "../API/Fetch";
import { store } from "../store";

export default async function fetchBrands() {
  let result = await fetchData(`/brands/`);

  if (result && result.length > 0) {
    // Extract collaborator IDs from the collaborators objects
    const brandsWithCollaboratorIds = result.map((brand) => ({
      ...brand,
      collaborators: brand.collaborators
        ? brand.collaborators.map((c) => c.id)
        : [],
    }));

    store.dispatch({
      type: "brands/update",
      payload: brandsWithCollaboratorIds,
    });
    return brandsWithCollaboratorIds;
  }

  store.dispatch({
    type: "brands/update",
    payload: result ? result : [],
  });
  return result;
}
